/**
 * @author - Andy Howell
 *
 *
 */
(function () {
    'use strict';

    /*global angular*/
    angular.module('vhols')

        .controller('HomePageController', ['$scope', 'deviceDetection', '$cookies', function ($scope, deviceDetection, $cookies) {
            $scope.device = deviceDetection.getDevice();

            angular.element(document).ready(function () {

                function accessGranted(position) {
                    var expireDate = new Date();
                    expireDate.setFullYear(expireDate.getFullYear() + 1);
                }

                function showError(error) {}
            });
        }])

        .controller('SwipeScrollCtrl', function ($scope, $element) {
            $scope.swipe = function (direction) {
                vhols.angEl($element[0].getElementsByClassName(direction)[0]).triggerHandler('click');
            };
        });
})();
